
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { StyleSelector } from "@/components/signature/StyleSelector";
import { Loader2 } from "lucide-react";
import type { SignatureInputProps } from "@/types/signature";

interface SignatureFormProps extends Pick<SignatureInputProps, "value" | "onChange" | "onSubmit" | "style" | "onStyleChange"> {
  disabled?: boolean;
}

export const SignatureForm = ({ 
  value, 
  onChange, 
  onSubmit,
  style,
  onStyleChange,
  disabled = false
}: SignatureFormProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && value.trim() && !disabled) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <div className="flex-none">
        <StyleSelector style={style} onStyleChange={onStyleChange} disabled={disabled} />
      </div>
      <div className="flex-grow">
        <Input 
          type="text" 
          placeholder="Type your name..." 
          value={value} 
          onChange={(e) => onChange(e.target.value)} 
          onKeyDown={handleKeyDown}
          className="w-full h-20 text-xl font-normal bg-white border-0 rounded-2xl px-6"
          style={{ fontSize: '1.25rem' }}
          disabled={disabled}
        />
      </div>
      <Button 
        className="h-20 w-full md:w-auto px-8 rounded-2xl bg-[#FF2F00] hover:bg-[#FF2F00]/90 text-xl font-normal relative disabled:opacity-50 [&_svg]:w-6 [&_svg]:h-6" 
        onClick={onSubmit}
        disabled={!value.trim() || disabled}
      >
        <div className="flex items-center gap-2">
          <span>Generate</span>
          {disabled ? (
            <Loader2 className="h-6 w-6 animate-spin" />
          ) : (
            <>
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className="text-white stroke-current"
              >
                <path 
                  d="M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-xl">1</span>
            </>
          )}
        </div>
      </Button>
    </div>
  );
};
